import { combineReducers } from 'redux-immutable';
import phoneNumber from './ChangePhoneNumber/reducer';

export default combineReducers({
  phoneNumber
});
